export default __webpack_public_path__ + "static/media/Handle_DHP504.1824e356.obj";